module.exports = __webpack_public_path__ + "img/panda1.a0f7b985.png";